import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getCurrentApp } from "app/api/localTools"

export default class {
  @observable sectionList = []
  @observable templates = []

  @action loadSectionList() {
    return request.get(`${config.backend}/${getCurrentApp()}/apps`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.sectionList = res
      })
  }

  @action getTemplates(orgId) {
    return request.get(`${config.backend}/templates/${getCurrentApp()}?orgId=${orgId}`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.templates = res
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/entrance.js